import regCartStatusReducer from './regCartStatus';
import textReducer from 'event-widgets/redux/modules/text';
import websiteReducer from './website';
import pathInfoReducer from './pathInfo';
import capacity from 'event-widgets/redux/modules/capacity';
import registrationForm from './registrationForm/reducer';
import regCartPricing from './regCartPricing';
import countries from 'event-widgets/redux/modules/country';
import registrantLoginReducer from './registrantLogin';
import contactForm from './contactForm';
import stateReducer from 'event-widgets/redux/modules/state';
import dialogContainer from 'nucleus-guestside-site/src/redux/modules/dialogContainer';
import contactPlanner from './contactPlanner';
import timezonesReducer from './timezones';
import airportsReducer from './airports';
import userSessionReducer from './userSession';
import sessionFiltersReducer from './sessionFilters';
import { optOutReducer } from '../widgets/OptOut/redux';
import { unsubscribeReducer } from '../widgets/Unsubscribe/redux';
import eventTravelReducer from 'event-widgets/redux/modules/eventTravel';
import travelCartReducer from './travelCart';
import { personaReducer } from './persona';
import appDataReducer from './appData';
import fetchTextResolverDatatags from './datatags';
import visibleProductsReducer from './visibleProducts';
import customFontsReducer from 'nucleus-widgets/redux/modules/customFonts';
import { eventSnapshotReducer, accountSnapshotReducer } from './snapshot';
import currenciesReducer from './currencies';
import sessionsInWaitlistReducer from './sessionsInWaitlist';

const reducer = (state, action) => {
  const timezones = timezonesReducer(state.timezones, action);
  const eventTimezone = state.event ? timezones[state.event.timezone] : undefined;
  return {
    accessToken: state.accessToken,
    account: accountSnapshotReducer(state.account, action, 'account'),
    userSession: userSessionReducer(state.userSession, action),
    sessionFilters: sessionFiltersReducer(state.sessionFilters, action),
    accountSnapshotVersion: accountSnapshotReducer(state.accountSnapshotVersion, action, 'version'),
    appData: appDataReducer(state.appData, action, state),
    capacity: capacity(state.capacity, action),
    clients: state.clients,
    contactForm: contactForm(state.contactForm, action),
    contactPlanner: contactPlanner(state.contactPlanner, action),
    countries: countries(state.countries, action),
    dialogContainer: dialogContainer(state.dialogContainer, action),
    event: eventSnapshotReducer(state.event, action, 'event'),
    eventSnapshotVersion: eventSnapshotReducer(state.eventSnapshotVersion, action, 'version'),
    optOut: optOutReducer(state.optOut, action),
    unsubscribe: unsubscribeReducer(state.unsubscribe, action),
    pathInfo: pathInfoReducer(state.pathInfo, action),
    registrationForm: registrationForm(state.registrationForm, action),
    regCartPricing: regCartPricing(state.regCartPricing, action),
    regCartStatus: regCartStatusReducer(state.regCartStatus, action),
    registrantLogin: registrantLoginReducer(state.registrantLogin, action),
    states: stateReducer(state.states, action),
    text: textReducer(state.text, action, eventTimezone),
    timezones,
    airports: airportsReducer(state.airports, action),
    website: websiteReducer(state.website, action),
    widgetFactory: state.widgetFactory,
    googleMap: state.googleMap,
    environment: state.environment,
    plannerRegSettings: state.plannerRegSettings,
    testSettings: state.testSettings,
    eventTravel: eventTravelReducer(state.eventTravel, action),
    travelCart: travelCartReducer(state.travelCart, action),
    persona: personaReducer(state.persona, action),
    fetchTextResolverDatatags,
    eventLaunchWizardSettings: state.eventLaunchWizardSettings,
    visibleProducts: visibleProductsReducer(state.visibleProducts, action),
    customFonts: customFontsReducer(state.customFonts, action),
    currencies: currenciesReducer(state.currencies, action),
    selectSessionsInWaitlist: sessionsInWaitlistReducer(state.selectSessionsInWaitlist, action)
  };
};

export default reducer;

/* put exported child selectors below this comment */
export function getAdmissionItems(state) {
  return state.event.products.admissionItems;
}

export function getEventTimezone(state) {
  return state.timezones[state.event.timezone];
}

export function getAccountSessionCategories(state) {
  return state.account.sessionCategories;
}

/**
 * Return all rooms having fee enabled
 * @param {Object} state
 * @returns {Array}
 */
export function getPaidRooms(state) {
  return state.eventTravel.hotelsData.hotels.reduce((accumulator, hotel) => {
    const newAccumulator = { ...accumulator };
    if (hotel.roomTypes) {
      hotel.roomTypes.forEach((roomType) => {
        if (roomType.fee && roomType.fee.isActive) {
          newAccumulator[roomType.id] = {
            ...roomType,
            hotelName: hotel.name
          };
        }
      });
    }
    return newAccumulator;
  }, {});
}

/**
* Gets the session custom fields definitions from the account snapshot
*/
export function getSessionCustomFieldDefinitions(state) {
  return state.account.sessionCustomFields;
}
